// Projects.js

// Function to load images dynamically
function importAll(r) {
    let images = {};
    r.keys().forEach((item) => {
        images[item.replace('./', '')] = r(item);
    });
    return images;
}

// Import all images from folders
const projectImages = importAll(require.context('../images/project', false, /\.(jpg|jpeg|png)$/));
const projectSingleImages = importAll(require.context('../images/project-single', false, /\.(jpg|jpeg|png)$/));

// Define projects
const Projects = [
    {
       Id:'1',
       pImg: projectImages['img-1.jpg'],
       ps1img: projectSingleImages['img-1.jpg'],
       psub1img1: projectSingleImages['p1.jpg'],
       psub1img2: projectSingleImages['p2.jpg'],
       title:'Social Media Post Design for Watch Brands',  
       subTitle:'Luxury Watch Marketing & Brand Promotion',   
    },
    {
       Id:'2',
       pImg: projectImages['img-2.jpg'],
       ps1img: projectSingleImages['img-2.jpg'],
       psub1img1: projectSingleImages['p1.jpg'],
       psub1img2: projectSingleImages['p2.jpg'],
       title:'Brand Identity Design for Businesses', 
       subTitle:'Build a Strong Visual Identity that Defines Your Brand',    
    },
    {
       Id:'3',
       pImg: projectImages['img-3.jpg'],
       ps1img: projectSingleImages['img-3.jpg'],
       psub1img1: projectSingleImages['p1.jpg'],
       psub1img2: projectSingleImages['p2.jpg'],
       title:'Social Media Post Design for Online Marketing',  
       subTitle:'Engage Your Audience and Grow Your Business with Creative Visuals',   
    },
    {
       Id:'4',
       pImg: projectImages['img-4.jpg'],
       ps1img: projectSingleImages['img-2.jpg'],
       psub1img1: projectSingleImages['p1.jpg'],
       psub1img2: projectSingleImages['p2.jpg'],
       title:'Social Media Marketing Designs for Bakery Products', 
       subTitle:'Elevate Your Bakery’s Online Presence with Irresistible Visuals',    
    },
    // Add new projects easily:
    {
       Id:'5',
       pImg: projectImages['img-5.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Professional Business Card Design for Your Brand',  
       subTitle:'Create Memorable and Impactful Cards That Leave a Lasting Impression',   
    },
    {
       Id:'6',
       pImg: projectImages['img-6.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'3D Product Visualization Services',  
       subTitle:'Showcase Your Products in Realistic 3D for Marketing and E-Commerce',   
    },
    {
       Id:'7',
       pImg: projectImages['img-7.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'3D Serum Bottle Visualization',  
       subTitle:'Realistic 3D Product Renderings to Showcase Your Skincare Brand',   
    },
    {
       Id:'8',
       pImg: projectImages['img-8.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Professional Logo Design Services',  
       subTitle:'Craft Unique Logos That Define Your Brand Identity',   
    },
    {
       Id:'9',
       pImg: projectImages['img-9.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Social Media Post Design',  
       subTitle:'Engage Your Audience and Grow Your Brand with Creative Visuals',   
    },
    {
       Id:'10',
       pImg: projectImages['img-10.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Social Media Marketing Designs for Watches',  
       subTitle:'Boost Your Watch Brand Online Presence with Eye-Catching Posts',   
    },
    {
       Id:'11',
       pImg: projectImages['img-11.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Creative Social Media Designs for Bakery Brands',  
       subTitle:'Showcase Your Baked Goods with Stunning, Mouth-Watering Posts',   
    },
    {
       Id:'12',
       pImg: projectImages['img-12.jpg'],
       ps1img: projectSingleImages['img-4.jpg'],
       psub1img1: projectSingleImages['p3.jpg'],
       psub1img2: projectSingleImages['p4.jpg'],
       title:'Creative Social Media Posts for Digital Marketing',  
       subTitle:'Boost Engagement and Drive Results with Eye-Catching Designs',   
    },
]

export default Projects;
